import LowBatteryIcon from '../../../assets/1.svg?react';
import HighWarningIcon from '../../../assets/2.svg?react';
import AllDevicesIcon from '../../../assets/3.svg?react';
// import HighBatteryIcon from '../../../assets/4.svg?react';
import MissedTransmission from '../../../assets/5.svg?react';
import WeatherModeIcon from '../../../assets/6.svg?react';
// import FillPercentageIcon from '../../../assets/7.svg?react';

import { useRecoilValue } from 'recoil';
import {
  deviceListStateAtom,
  deviceModeAtom,
} from '../../../models/atoms/device_atoms';
import { calculateMissingMessagesDevices } from '../../../utils/helper_functions';
import React from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { Paper, Stack, SvgIcon, Tooltip } from '@mui/material';
import { MHMTypography } from '../MHM/MHMTypography';
import { deviceListInterface } from '../../../models/interfaces/device_interfaces';

export function computeMetrics(totalDevices: deviceListInterface) {
  return [
    {
      icon: AllDevicesIcon,
      value: totalDevices.devices.length,
      title: 'Total Devices Deployed',
    },
    {
      icon: HighWarningIcon,
      value: totalDevices.devices.filter(device => device.warning_level === 10)
        .length,
      title: 'High Warning Devices',
    },
    {
      icon: LowBatteryIcon,
      value: totalDevices.devices.filter(
        device => device.battery_percentage < 25,
      ).length,
      title: 'Low Battery Devices',
    },
    {
      icon: MissedTransmission,
      value: calculateMissingMessagesDevices(totalDevices.devices),
      title: 'Devices With Missed Transmissions',
    },
    {
      icon: WeatherModeIcon,
      value: totalDevices.devices.filter(
        device => device.device_weathermode_on === true,
      ).length,
      title: 'Devices in Weather Mode',
    },
    // Temporary remove these 2 icons
    // {
    //   icon: HighBatteryIcon,
    //   value: calculateAverageBattery(totalDevices.devices),
    //   title: 'Average Battery Percentage',
    // },
    // {
    //   icon: FillPercentageIcon,
    //   value: calculateAverageFillPercentage(totalDevices.devices, blind_distance),
    //   title: 'Average Fill Percentage',
    // }
  ];
}

export const FleetMetrics = (
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  const { t } = useTranslation();
  const totalDevices = useRecoilValue(deviceListStateAtom);
  const data = computeMetrics(totalDevices);
  const mode = useRecoilValue(deviceModeAtom);

  if (mode === 'archived') {
    return null;
  }

  return (
    <Paper
      data-testid="Fleet Metrics Component"
      sx={[
        {
          width: '8rem',
          position: 'absolute',
          margin: '1rem',
          right: '1rem',
          top: '1rem',
          overflow: 'hidden',
          maxHeight: 'fit-content',
          height: 'calc(100% - 4rem)',
        },
      ]}
    >
      <Stack
        sx={{
          maxHeight: '100%',
          padding: 1.25,
          overflowY: 'scroll',
        }}
        gap={1}
      >
        <MHMTypography bold textAlign="center">
          {t('Summary')}
        </MHMTypography>
        {data.map(item => (
          <Stack
            key={item.title}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
          >
            <Tooltip title={t(item.title)} placement="left">
              <SvgIcon color="primary" inheritViewBox sx={{ fontSize: '32px' }}>
                <item.icon />
              </SvgIcon>
            </Tooltip>
            <MHMTypography fontSize="24px">{item.value}</MHMTypography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};
